module.exports = __webpack_public_path__ + "static/media/metronome.88017da0.svg";